class Ifr {
  constructor() {
    this.listeners = {};
    window.addEventListener('message', this.listenMessage.bind(this));
  }

  /**
   * Add a callback on segment passing in settings
   * @param {Array<string>} eventNames  Array of event name
   * @param callback
   */
  add(eventNames, callback) {
    for (const eventName of eventNames) {
      const listeners = this.listeners[eventName] || [];
      listeners.push(callback);
      this.listeners[eventName] = listeners;
    }
  }

  listenMessage(e) {
    try {
      const data = JSON.parse(e.data);
      const eventName = data.type;
      const listeners = this.listeners[eventName];
      if (listeners) {
        listeners.forEach(fn => fn(data));
      }
    } catch (error) {
      //Swallow
    }
  }

  remove(eventNames, callback) {
    for (const eventName of eventNames) {
      const listeners = this.listeners[eventName] || [];
      const index = listeners.indexOf(callback);
      if (index !== -1) {
        listeners.splice(index, 1);
      }
    }
  }

  send(functionName, functionParams) {
    window.parent.postMessage(
      JSON.stringify({
        // 'js' Attribute is deprecated and only there for backward compatiblity with eval in banners
        js: `tC.privacy.${functionName}(${functionParams})`,
        functionName: functionName,
        params: functionParams,
      }),
      '*'
    );
  }
  sendSetCat(settings, consents) {
    const json = {
      idPrivacy: settings.id,
      version: settings.version,
      ...consents,
    };

    this.send('setCat', JSON.stringify(json));
  }
  sendReady() {
    window.parent.postMessage(JSON.stringify({ type: 'ready' }), '*');
  }
}

export const ifr = new Ifr();
